import React, { useState, useEffect } from 'react';
import { ethers } from 'ethers';
import { CONTRACTS } from '../contracts/addresses';
import { VAULT_ABI } from '../contracts/abis';

function WithdrawForm({ signer, account, provider, onSuccess }) {
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');
  const [maxWithdraw, setMaxWithdraw] = useState('0');

  useEffect(() => {
    loadMaxWithdraw();
  }, [provider, account]);

  const loadMaxWithdraw = async () => {
    if (!provider || !account) return;
    try {
      const vault = new ethers.Contract(CONTRACTS.vault, VAULT_ABI, provider);
      const shares = await vault.balanceOf(account);
      
      if (shares.gt(0)) {
        const assets = await vault.convertToAssets(shares);
        setMaxWithdraw(ethers.utils.formatUnits(assets, 6));
      } else {
        setMaxWithdraw('0');
      }
    } catch (error) {
      console.error('Error loading max withdraw:', error);
    }
  };

  const setMaxAmount = () => {
    setAmount(maxWithdraw);
  };

  const handleWithdraw = async () => {
    if (!amount || parseFloat(amount) <= 0) {
      setStatus('Enter amount');
      return;
    }

    if (parseFloat(amount) > parseFloat(maxWithdraw)) {
      setStatus('Insufficient balance');
      return;
    }

    setLoading(true);
    setStatus('Withdrawing...');

    try {
      const vault = new ethers.Contract(CONTRACTS.vault, VAULT_ABI, signer);
      const amountWei = ethers.utils.parseUnits(amount, 6);

      const tx = await vault.withdraw(amountWei, account, account);
      await tx.wait();

      setStatus('Success!');
      setAmount('');
      await loadMaxWithdraw();
      if (onSuccess) onSuccess();
      
      setTimeout(() => setStatus(''), 3000);
    } catch (error) {
      console.error('Withdraw error:', error);
      if (error.code === 4001) {
        setStatus('Cancelled');
      } else {
        setStatus('Failed: ' + (error.reason || 'Unknown error'));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-card">
      <h3>Withdraw</h3>
      
      <div className="input-group">
        <input
          type="number"
          placeholder="0.00"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          disabled={loading}
        />
        <button className="max-btn" onClick={setMaxAmount} disabled={loading}>
          MAX
        </button>
        <span className="suffix">USDC</span>
      </div>

      <div className="balance-text">
        Available: {parseFloat(maxWithdraw).toFixed(2)} USDC
      </div>

      <button 
        className="submit-btn withdraw-btn"
        onClick={handleWithdraw}
        disabled={loading || !amount || parseFloat(amount) <= 0}
      >
        {loading ? 'Processing...' : 'Withdraw'}
      </button>

      {status && (
        <div className={`status ${
          status === 'Success!' ? 'success' : 
          status.includes('Failed') ? 'error' : 
          'info'
        }`}>
          {status}
        </div>
      )}
    </div>
  );
}

export default WithdrawForm;